import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environments/environment';
import urlJoin from 'url-join';

@Pipe({
  name: 'assets',
  standalone: true,
})
export class AssetsPipe implements PipeTransform {
  transform(path: string): string {
    return urlJoin(environment.assetsUrl, path);
  }
}
